import React from "react";
import LegalLayout from "./_LegalLayout";

const H = ({ children }) => (
  <h2 className="font-display text-xl sm:text-2xl font-semibold text-ink-900 tracking-tight mt-8">
    {children}
  </h2>
);

const CompanyInformation = () => (
  <LegalLayout
    testId="page-company-information"
    overline="Legal · Company Information"
    title="Company Information / Legal Notice"
    lead="Identification and contact information for the operating brand owner behind the Allinstra website."
  >
    <H>Brand</H>
    <p>Allinstra is an institutional systems brand by Erenown.</p>

    <H>Primary website operator</H>
    <div className="border border-ink-200 bg-ink-50 p-5">
      <div className="font-semibold text-ink-900">Erenown LLC</div>
      <div>Bulevardi Dëshmorët e Kombit, C2, HIII, Nr.6</div>
      <div>Prishtinë, Republic of Kosovo</div>
      <div>Registration number: 811869512</div>
    </div>

    <H>Separate UK company under the same ultimate beneficial ownership and control</H>
    <div className="border border-ink-200 bg-ink-50 p-5">
      <div className="font-semibold text-ink-900">Erenown Ltd</div>
      <div>83 St. Marks Road, Enfield, England, EN1 1BJ</div>
      <div>United Kingdom</div>
      <div>Company number: 12845592</div>
    </div>

    <H>General contact</H>
    <p>
      <a href="mailto:info@allinstra.com" className="underline">info@allinstra.com</a>
    </p>

    <H>Status note</H>
    <p>
      Erenown Ltd and Erenown LLC are separate companies. Publication of both entities on this
      website does not mean that one is a branch, subsidiary, affiliate, or office of the
      other unless expressly stated in a specific contract or legal instrument.
    </p>

    <H>Operating note</H>
    <p>
      Depending on geography, service scope, and contract allocation, a specific service may
      be offered by Erenown LLC, Erenown Ltd, or another company under the same ultimate
      beneficial ownership and control, provided the contracting entity is clearly identified.
    </p>
  </LegalLayout>
);

export default CompanyInformation;
